import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";
import AgGridWrapper from "../../su/AgGridWrapper.js";

export default class PageUsersList extends PageList {
    constructor() {
        super();
    }

    onAdd() {
        let args = StateManager._splitUrl(document.location.href);
        document.location.href = TheApp.Env.BaseUrlNls + "users/detail?_pi=" + encodeURIComponent(args.qPart["_pi"]);
    }


    // INIZIO COPIA INCOLLA
    initAgList() {
        // Prepara i dati per la griglia (normalmente sono in this.data.rows quindi non c'è bisogno di fare nulla)
        const rowData = [];
        for (let x = 0; x < this.data.rows.length; x++) {
            const row = this.data.rows[x];
            rowData.push(row);
        }
        this.rowData = rowData;

        // Search box (deve puntare all'id dell'input)
        const searchBox = document.getElementById("filter-text-box");

        // Punta alla griglia e ne imposta l'altezza
        const targetGrid = document.querySelector(".js-aglist");
        const h = this.getAvailableHeight();
        targetGrid.style.height = h + "px";

        // Definizione delle colonne (questa è la parte da toccare)
        const columnDefs = [
            {
                field: "UserName",
                headerName: "UserName",
                flex: 3.5,
            },
            {
                field: "DisplayName",
                headerName: "DisplayName",
                flex: 3.5,
            },
            {
                field: "StatusLabel",
                headerName: "Status",
                flex: 1,
            },
        ];

        // Inizializzazione della griglia (Copia incolla tranne il primo parametro che è un id arbitrario ma usiamo generalmente il nome della pagina)
        let agGrid = new AgGridWrapper("PageUsersList", AgGridWrapper.MODE_SIMPLE);
        const options = agGrid.getConfig({
            onRowClicked: this.onRowClicked.bind(this),
            customOptions: {
                doNotshowSelection: true, // In modo casereccio non mostra la selezione
                removeOldList: true, // Rimuove la vecchia griglia dalla pagina (punta sul fatto che i nodi che la contengono si chiamino "jsList" e "filterbox" grazie al solito copia-incolla selvaggio)
            },
            columnDefs,
            rowData,
        });

        // Crea la griglia e ascolta il resize della finestra per cambiare l'altezza
        agGrid.init(targetGrid, searchBox, options);
        window.onresize = this.arrangeGrid.bind(this, agGrid);
    }

    arrangeGrid(agGrid) {
        // Punta alla griglia e ne imposta l'altezza
        const targetGrid = document.querySelector(".js-aglist");
        const h = this.getAvailableHeight();
        targetGrid.style.height = h + "px";
    }

    onRowClicked(params) {
        // Click sulla riga che porta alla pagina di dettaglio
        document.location.href = TheApp.Env.BaseUrlNls + "users/detail/" + Base64.toBase64(params.data.Uid, true) + "?__pi=" + this.data.page.PageId;
    }
    // FINE COPIA INCOLLA

}

